import { FormField, Input } from '@wix/design-system';
import { DataHooks } from '../../../../../constants/dataHooks';
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSelfHostedContext } from '../SelfHostedModalContextProvider';
import { useTemplatesData } from '../../../../../hooks/useTemplatesData';
import { useTemplatesPageBi } from '../../../../../hooks/useTemplatesPageBi';

export const AppNameInput = () => {
  const { t } = useTranslation();
  const { formData, updateAppName } = useSelfHostedContext();
  const { currentTemplate: template } = useTemplatesData();
  const { reportInputFocused } = useTemplatesPageBi();
  const { appName } = formData;

  return (
    <FormField
      required
      label={t('app.template-page.modal.self-hosted.step2.app-name')}
    >
      <Input
        required
        onFocus={() =>
          reportInputFocused(template.id, 'use template - appName')
        }
        dataHook={DataHooks.SelfHostModalAppNameInput}
        value={appName}
        onChange={(e) => updateAppName(e.target.value)}
      />
    </FormField>
  );
};
